<template>
  <div>
    <div class="vx-row mt-5">
      <div class="vx-col w-full">
        <p>Haz una transferencia desde tu cuenta internacional a la siguiente cuenta destino y <b>registra
            tu abono</b>.</p>
        <p class="mt-5">
          <b>Nombre beneficiario</b><br>
        <div class="flex justify-start">
          <span>
            {{ rgName }}
          </span>
          <feather-icon icon="CopyIcon" class="ml-3 cursor-pointer" svg-classes="h-5 w-5"
            @click.stop="copyToClipboard(rgName)" />
        </div>
        </p>
        <div class="flex justify-start">
          <div class="mt-5">
            <b>Cuenta destino</b>
            <div class="flex justify-start">
              <span>
                {{ rgAccount }}
              </span>
              <feather-icon icon="CopyIcon" class="ml-3 cursor-pointer" svg-classes="h-5 w-5"
                @click.stop="copyToClipboard(rgAccount)" />
            </div>
          </div>
          <div class="mt-5 ml-base">
            <b>Clave SWIFT</b>
            <div class="flex justify-start">
              <span>
                {{ rgSwift }}
              </span>
              <feather-icon icon="CopyIcon" class="ml-3 cursor-pointer" svg-classes="h-5 w-5"
                @click.stop="copyToClipboard(rgSwift)" />
            </div>
          </div>
        </div>
        <p class="mt-5">
          <b>Banco</b><br>
          {{ rgBank }}
        </p>
        <p class="mt-5">
          <b>Domicilio</b><br>
          {{ rgAddress }}
        </p>
        <p class="mt-5">
          <vs-alert icon-pack="feather" icon="icon-info" class="h-full" color="dark">
            Los abonos internacionales pueden tomar hasta 7 días hábiles para verse reflejados en tu cuenta
            de inversión. Es posible que algunos bancos cobren comisiones por realizar transferencias
            internacionales, por lo que el abono a tu cuenta de inversión puede ser menor que el monto que
            transferiste.
            Consulta nuestra <a :href="fintechAutorizationUrl" target="_blank" class="underline black">Autorización Fintech</a> y autorización para realizar
            <a :href="internationalTransfersUrl" target="_blank" class="underline black">Transferencias internacionales</a>. Consulta la <a href="#" class="underline black" @click="goToGafiBlog()">lista</a> de
            países con restricciones.
          </vs-alert>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fintechAutorizationUrl: "https://dof.gob.mx/nota_detalle.php?codigo=5651691&fecha=11/05/2022#gsc.tab=0",
      internationalTransfersUrl: "https://cdn.redgirasol.com/informativos/CNBV_RED_GIRASOL_TRANSF_INTERN_AUTORIZACION_311_58587_2024.pdf",
      rgName: "Red Girasol S.A.P.I. de C.V., Institución de Financiamiento Colectivo",
      rgAddress: "Av. Pedro Ramirez Vazquez 200, Parque Corporativo Ucaly, CP 66278, San Pedro Garza García, Nuevo León",
      rgAccount: "950485270033",
      rgSwift: "RGIOMXMT",
      rgBank: "Banco Regional S.A. Institución de Banca Múltiple, Banregio Grupo Financiero"
    }
  },
  methods: {
    async copyToClipboard(value) {
      const el = document.createElement('textarea');
      el.value = value;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.successNotif("Aviso", "Texto copiado exitosamente", 2000);
    },
    goToGafiBlog() {
      window.open("https://soporte.redgirasol.com/support/solutions/articles/48001264004-pa%C3%ADses-restringidos-para-realizar-transacciones", "_blank");
    }
  }
}
</script>
